import { useStaticQuery, graphql } from "gatsby"

export const useContactQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query ContactQuery {
            wpPage(title: {eq: "Home"}) {
              contact {
                contactBackgroundImageMobile {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
                contactBackgroundImageDesktop {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: FULL_WIDTH)
                    }
                  }
                }
                contactBackgroundImageAltText
                contactHeading
                contactSubheading
              }
            }
          }
        `)
return wpPage.contact
}